'use client'

import { isNull } from 'lodash-es'

import { useIOSGeolocation } from './iOS-geolocation'
import { useWebGeolocation } from './web-geolocation'
import { useMapBridge } from '../bridge'
import { TCoordinates } from '../map-manager'

const DEFAULT_ERROR_MESSAGE = '내 위치를 불러오지 못했습니다'

export const useGeolocation = () => {
  const { bridge } = useMapBridge()

  const { getWebUserLocation } = useWebGeolocation()
  const { getIOSUserLocation } = useIOSGeolocation()

  const handleGeolocationError = (error: GeolocationPositionError) => {
    if (error.code === error.PERMISSION_DENIED) {
      alert('내 위치를 사용할 수 있는 권한이 없습니다')
    } else {
      alert(DEFAULT_ERROR_MESSAGE)
    }
  }

  const getGeolocationPosition = async () => {
    try {
      let coordinates: TCoordinates | null = null

      if (bridge?.environment.platform === 'ios') {
        coordinates = await getIOSUserLocation()
      } else {
        coordinates = await getWebUserLocation()
      }

      return convertToLatLng(coordinates)
    } catch (error) {
      if (error instanceof GeolocationPositionError) {
        handleGeolocationError(error)
      } else {
        alert(DEFAULT_ERROR_MESSAGE)
      }

      return null
    }
  }

  const convertToLatLng = (position: TCoordinates | null) => {
    if (isNull(position)) {
      return null
    }

    return new naver.maps.LatLng(position.lat, position.lng)
  }

  return {
    getGeolocationPosition,
  }
}
